import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../state/hooks';
import {
  selectLoading,
  selectOutputBrands,
  selectSelectedOutputBrands,
  updateSelectedOutputBrands,
} from '../../../../features/outputSegmentDeepDive/outputBrandsSlice';
import { hideLoader, showLoader } from '../../../../features/ui/loaderSlice';
import { RootState } from '../../../../state/store';
import { SCENARIO_OUTPUT_DATA } from '../../../../utils/dataConstants';
import { fetchSegmentDeepDive } from '../../../../features/outputSegmentDeepDive/outputSegmentDeepDiveSlice';
import { SelectMapperKeys, ViewByMapperKeysForDeepdive } from '../../../../types/common';
import { DynamicDropdown } from '../../../../components/UI/DynamicDropdown/DynamicDropdown';

export const BrandDropdown: React.FC = () => {
  const dispatch = useAppDispatch();
  const outputBrands = useAppSelector(selectOutputBrands);
  const selectedOutputBrands = useAppSelector(selectSelectedOutputBrands);
  const loading = useAppSelector(selectLoading);
  const { selectedToggle, selectedViewBy, enabledKeys } = useAppSelector((state: RootState) => state.outputFilters);
  const { selectedScenarios } = useAppSelector((state: RootState) => state.outputSegmentDeepDive);

  const handleApply = async (newSelected: string[]) => {
    await dispatch(showLoader());
    await dispatch(updateSelectedOutputBrands(newSelected));
    const segmentPayload = {
      scenario_1: selectedScenarios.base,
      scenario_2: selectedScenarios.child,
      brand: newSelected,
      bottler: enabledKeys.bottler,
      state: enabledKeys.state,
      select: SCENARIO_OUTPUT_DATA.SELECT_MAPPER[selectedToggle as SelectMapperKeys],
      view_by: SCENARIO_OUTPUT_DATA.VIEW_BY_MAPPER_DEEPDIVE[selectedViewBy as ViewByMapperKeysForDeepdive],
    };

    await dispatch(fetchSegmentDeepDive(segmentPayload));
    await dispatch(hideLoader());
  };

  return (
    <DynamicDropdown
      label="Brands: "
      options={outputBrands}
      selectedOptions={selectedOutputBrands}
      onChange={handleApply}
      customStyle={{ width: '109px' }}
      borderColor={'grey'}
    />
  );
};
